/**
 * The item mall (ร้านหยก): looks bought with หยกเซียน (jade). Only appearance — fashion, back
 * skins and mounts — never strength, so nothing here decides a fight.
 */
export interface MallEntry {
  readonly kind: 'skin' | 'mount';
  readonly id: string;
  /** Price in jade. */
  readonly price: number;
  /** Shown as new or limited in the mall. */
  readonly tag?: string;
}

export const MALL: readonly MallEntry[] = [
  { kind: 'skin', id: 'azure-fox', price: 680, tag: 'ใหม่' },
  { kind: 'skin', id: 'purple-dew', price: 480 },
  { kind: 'skin', id: 'violet-fan-swords', price: 880, tag: 'ยอดนิยม' },
];

/** Jade earned for deeds, besides what is topped up (see topup.ts). */
export const JADE = { questTurnIn: 30, worldBoss: 120 } as const;
